import { useQuery } from '@tanstack/react-query'
import { adminApi } from '@/api/admin'
import { portalApi } from '@/api/portal'
import { moneyFor, type Money } from '@/lib/money'

export type { Money }

/** Formatter for an explicit currency (a row that carries its own currency, e.g. a payment). */
export function useMoneyFor(currency?: string | null): Money {
  return moneyFor(currency)
}

/** Admin app: the tenant's currency from the shared company-profile query. */
export function useAdminMoney(): Money {
  const { data } = useQuery({
    queryKey: ['company-profile'],
    queryFn: () => adminApi.getCompanyProfile().then(r => r.data),
    staleTime: 5 * 60 * 1000,
  })
  return useMoneyFor(data?.currency)
}

/** Client portal: the tenant's currency from the branding query PortalLayout already loads. */
export function usePortalMoney(): Money {
  const { data } = useQuery({
    queryKey: ['portal-branding'],
    queryFn: () => portalApi.getBranding().then(r => r.data),
    staleTime: 5 * 60 * 1000,
  })
  return useMoneyFor(data?.currency)
}
